import React from 'react';
import { Box, List, Typography } from '@mui/material';
import OwnerRecentListItem from './OwnerRecentListItem';
import { useTranslation } from 'react-i18next';

const OwnersRecentList = ({owners, onClick, onPetClick, isMultiUser, onQuickEmailEdit, onQuickPhoneEdit}) => {
  const { t } = useTranslation();
  return (
    <Box 
      sx={{ 
        width: '100%', 
        borderRadius: 2,
        boxShadow: 3,
        bgcolor: 'background.paper',
      }}>

        <Typography 
          variant="caption" 
          noWrap 
          sx={{ 
            ml: 2,
            mt: 4,
          }}
        >
          {t('layouts.recentMovements')}
        </Typography>

      <List>
        {owners.map((owner) => (
          <OwnerRecentListItem
            key={owner.id}
            owner={owner}
            onClick={onClick}
            onPetClick={onPetClick}
            isMultiUser={isMultiUser}
            onQuickEmailEdit={onQuickEmailEdit}
            onQuickPhoneEdit={onQuickPhoneEdit}
          />
        ))}
      </List>
    </Box>
  );
};

export default OwnersRecentList;
